export default __webpack_public_path__ + "static/media/p57.f034094c.jpg";